export default __webpack_public_path__ + "1f372dfd38d537a4243f7339ea03b580.png";